<p-dialog [visible]="isVisible()" [modal]="true" [closable]="false" [closeOnEscape]="false" [draggable]="false"
  [resizable]="false" [style]="{ width: '92%', maxWidth: '440px' }"
  maskStyleClass="bg-slate-950/70 backdrop-blur-md z-50"
  styleClass="rounded-2xl overflow-hidden shadow-2xl border border-slate-200/80 dark:border-slate-800 bg-white dark:bg-slate-900">
  <div class="p-4 sm:p-6 text-center flex flex-col items-center">
    <!-- Warning Animated Icon Header -->
    <div class="relative mb-5 flex items-center justify-center">
      <div class="absolute -inset-1 rounded-full bg-amber-500/20 dark:bg-amber-500/10 animate-ping opacity-75"></div>
      <div
        class="relative w-16 h-16 rounded-2xl bg-amber-50 dark:bg-amber-950/50 border border-amber-200 dark:border-amber-800/60 flex items-center justify-center text-amber-600 dark:text-amber-400 shadow-inner">
        <i class="pi pi-clock text-3xl"></i>
      </div>
    </div>

    <!-- Title & Message -->
    <h3 class="text-xl font-bold text-slate-900 dark:text-slate-100 mb-2 tracking-tight">
      Session Inactivity Warning
    </h3>
    <p class="text-xs sm:text-sm text-slate-600 dark:text-slate-400 mb-6 max-w-xs leading-relaxed">
      You have been inactive for a while. For security reasons, your session will automatically log out in:
    </p>

    <!-- Timer Countdown Badge -->
    <div
      class="w-full bg-slate-50 dark:bg-slate-850 border border-slate-200/80 dark:border-slate-800 rounded-xl p-4 mb-6 shadow-xs">
      <div class="text-4xl font-extrabold text-amber-600 dark:text-amber-400 font-mono tracking-wider mb-3">
        {{ formattedRemainingTime() }}
      </div>
      <p-progressBar [value]="progressPercentage()" [showValue]="false"
        styleClass="h-2 rounded-full bg-slate-200 dark:bg-slate-800"></p-progressBar>
    </div>

    <!-- Action Buttons -->
    <div class="w-full flex flex-col sm:flex-row items-center justify-center gap-5">
      <p-button label="Keep Me Logged In" icon="pi pi-check-circle" size="small"
        styleClass="w-full sm:w-auto py-2 px-4 text-xs font-semibold rounded-xl border-none shadow-md transition-all duration-200 cursor-pointer whitespace-nowrap"
        (onClick)="onKeepLoggedIn()"></p-button>

      <p-button label="Log Out Now" icon="pi pi-power-off" severity="danger" size="small"
        styleClass="w-full sm:w-auto py-2 px-4 text-xs font-semibold rounded-xl border-none shadow-md transition-all duration-200 cursor-pointer whitespace-nowrap"
        (onClick)="onLogoutNow()"></p-button>
    </div>
  </div>
</p-dialog>